"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppName = void 0;
/**
 * Returns app name either from parameter or `window.appName`. Throws exception if app name cannot be determined.
 */
function getAppName(appName) {
    const resolvedAppName = appName !== null && appName !== void 0 ? appName : window.appName;
    if (!resolvedAppName) {
        throw new Error('App name is unknown, please either set window.appName or pass appName as an argument to this hook');
    }
    return resolvedAppName;
}
exports.getAppName = getAppName;
